// extracted by mini-css-extract-plugin
export default {"list":"vGnrMLz7kjMxVTVO9i8t","utility":"M8TtOLCbzSzslRSxJhGU","thumbnail":"kdO3Xcy5JiDgnHklovub","icon":"qQvhkqrk2bLrdBE5QArq"};